import { makeStyles } from '@mui/styles';
import { isFirefox } from '@shared/helpers/userAgent';
import { COLORS } from '@styles/colors';

export const useStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',

    '&:hover': {
      '& $tooltip': {
        display: 'block',
        visibility: isFirefox ? 'visible' : undefined,
      },
    },
  },
  tooltip: {
    display: isFirefox ? 'block' : 'none',
    visibility: isFirefox ? 'hidden' : undefined,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: -45,
    width: 'max-content',
    boxShadow: '0 4px 12px rgb(180 180 180 / 60%) !important',
    color: COLORS.TEXT.PRIMARY,
    fontWeight: '400',
    fontSize: '14px',
    padding: '5px 10px',
    background: COLORS.WHITE,
    borderRadius: 4,
    overflow: 'visible',
  },
  arrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderTop: '10px solid white',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    bottom: -7,
    left: '50%',
    transform: 'translateX(-50%)',
  },
});
